import { z } from 'zod';

import { AlertStatusSchema } from '@/entities/alert-status';

export enum NotificationChannel {
  Email = 'Email',
  Slack = 'Slack',
  Webhook = 'Webhook',
  SMS = 'SMS',
  SFTP = 'SFTP',
}

export enum NotificationFrequency {
  Daily = 'Daily',
  NewAlerts = 'NewAlerts',
}

const FrequencyEnumSchema = z.nativeEnum(NotificationFrequency);
const ChannelEnumSchema = z.nativeEnum(NotificationChannel);

export const AlertNotificationRuleSchema = z.object({
  id: z.string(),
  isEnabled: z.boolean(),
  description: z.string(),
  minAlertStatus: AlertStatusSchema,
  siteIds: z.array(z.string()),
  channels: z.array(ChannelEnumSchema),
  externalEmails: z.array(z.string().email()),
  frequency: FrequencyEnumSchema,
});

export const CreateAlertNotificationRuleSchema =
  AlertNotificationRuleSchema.omit({ id: true });

export const UpdateAlertNotificationRuleStatusSchema =
  AlertNotificationRuleSchema.pick({ id: true, isEnabled: true });

export type AlertNotificationRule = z.infer<typeof AlertNotificationRuleSchema>;
export type CreateAlertNotificationRule = z.infer<
  typeof CreateAlertNotificationRuleSchema
>;
export type UpdateAlertNotificationRuleStatus = z.infer<
  typeof UpdateAlertNotificationRuleStatusSchema
>;
